import React, { FC } from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import Loading from "../../../../components/Loading";
import Error from "../../../../components/Error";
import { useSchoolStudentsPage } from "../../context/schoolStudentsPageContext";
import { SchoolStudentListItem } from "./SchoolStudentListItem";

const useStyles = makeStyles(() => ({
  root: {
    padding: "24px 16px",
    minHeight: 245,
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 0px 8px #C2C9D682",
    borderRadius: 15,
    minWidth: 732,
    width: 732,
    position: "relative",
    overflow: "hidden",
  },
  loading: {
    position: "absolute",
  },
  title: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#231F20",
    paddingLeft: 8,
  },
  schoolStudentsCont: {
    marginTop: 26,
  },
  error: {
    marginTop: 74,
  },
}));

const FilterResults: FC = () => {
  const classes = useStyles();
  const { loading, schoolStudents = [] } = useSchoolStudentsPage();

  return (
    <div className={classes.root}>
      {!!loading && <Loading className={classes.loading} />}
      <>
        <Typography className={classes.title} component={"h2"}>
          Students
        </Typography>
        {
          <Grid container spacing={1} className={classes.schoolStudentsCont}>
            {schoolStudents.map((schoolStudent) => (
              <Grid key={schoolStudent.id} item md={2} sm={2} xs={2}>
                <SchoolStudentListItem
                  id={schoolStudent.id}
                  name={schoolStudent.name}
                  country={schoolStudent.country}
                  photo={schoolStudent.photo}
                  status={schoolStudent.status}
                  hasNewMessage={schoolStudent.hasNewMessage}
                />
              </Grid>
            ))}
          </Grid>
        }
        {!schoolStudents.length && !loading && (
          <Error
            className={classes.error}
            fullHeight={false}
            icon={"search"}
            text={"You have no results for now."}
          />
        )}
      </>
    </div>
  );
};

export default React.memo(FilterResults);
